import { apiRequest } from '../../api/client';

const unwrap = async <T>(promise: Promise<{ data: T }>): Promise<T> => (await promise).data;

/** Trạng thái đánh giá, khớp `MealReviewState` bên BE (serialize dạng chuỗi). */
export type MealReviewState = 'New' | 'Seen' | 'Replied';

/** Một đánh giá bữa ăn cho màn admin `a-review` (S8-BE-05, M13, BR-107). */
export interface AdminMealReview {
  id: string;
  memberId: string;
  memberCode: string;
  branchId: string;
  branchName: string;
  /** 1..5 sao. */
  rating: number;
  comment: string | null;
  /** Hóa đơn gắn được; null = không gắn hóa đơn nên không có điểm (BR-107). */
  billScanId: string | null;
  pointsAwarded: number;
  state: MealReviewState;
  replyText: string | null;
  repliedAt: string | null;
  createdAt: string;
}

export interface MealReviewPage {
  items: AdminMealReview[];
  total: number;
  /**
   * Số đánh giá CHƯA trả lời trong phạm vi chi nhánh (không đổi theo tab đang mở) — nguồn của
   * badge "còn bao nhiêu việc" đầu màn.
   */
  unansweredCount: number;
}

export interface MealReviewFilters {
  branchId?: string;
  state?: MealReviewState;
}

export const reviewKeys = {
  list: (filters: MealReviewFilters) => ['reviews', 'list', filters] as const,
};

export const reviewApi = {
  /** Danh sách đánh giá: chưa trả lời lên trước, rồi mới nhất. Lọc chi nhánh + trạng thái ở server (BR-801). */
  list: (filters: MealReviewFilters, skip = 0, take = 200) => {
    const params = new URLSearchParams();
    if (filters.branchId) params.set('branchId', filters.branchId);
    if (filters.state) params.set('state', filters.state);
    params.set('skip', String(skip));
    params.set('take', String(take));
    return unwrap(apiRequest<MealReviewPage>(`/admin/reviews?${params}`));
  },

  /** Trả lời một đánh giá — khách nhận thông báo ngay (M13). */
  reply: (id: string, replyText: string) =>
    unwrap(
      apiRequest<AdminMealReview>(`/admin/reviews/${id}/reply`, {
        method: 'POST',
        body: { replyText },
      }),
    ),
};
